<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" title="新增计划" width="580px" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" :size="size" ref="dataForm" label-position='right' label-width="120px" v-loading="dialogLoading">
      <el-form-item prop="contractId" label="合同">
        <el-select v-model="dataForm.contractId" @change="handleContractChange" style="width: 100%;" placeholder="" clearable>
          <el-option v-for="item in contractList" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="contractProjectId" label="关联项目">
        <el-select v-model="dataForm.contractProjectId" style="width: 100%;" placeholder="" clearable>
          <el-option v-for="item in projectList" :value="item.projectId" :label="item.projectName" :key="item.projectId"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button class="submit" :size="size" type="primary" @click="submitHandle()" :loading="dialogLoading">确 定</el-button>
      <el-button class="close" :size="size" @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  name: 'addPlanOfProject',
  data () {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      size: 'small',
      dialogLoading: false,
      visible: false,
      contractList: [],
      projectList: [],
      dataForm: {
        contractId: '',
        projectId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        contractId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        contractProjectId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.contractList = []
      this.projectList = []
      this.dataForm = {
        companyId: 0,
        contractId: '',
        contractProjectId: ''
      }
      this.$api.electricOperations.listElectricOperationsContractForServiceProvider(0, '', '', null, 1).then((res) => {
        if (res.success) {
          this.contractList = res.data
        }
      })
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
      })
    },
    handleContractChange (contactId) {
      this.projectList = []
      this.$api.contract.getContractProjectByContractId({
        companyId: 0,
        contactId: [contactId]
      }).then((res) => {
        if (res.success) {
          this.projectList = res.data
        }
      })
    },
    submitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dialogLoading = true
        this.$api.electricOperations.addElectricOperationsPlanByContractServiceItem({ ...this.dataForm }).then((res) => {
          this.dialogLoading = false
          if (res.success) {
            this.$message.success('操作成功')
            this.visible = false
            this.$emit('handleQuery')
          }
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }) 
  }
}
</script>

<style>

</style>